window.showSearchBox = function(){
    $('#search-link').hide();
    $('#close-search-link').show();
    $('header nav .standard-link').hide();
    $('#loading-search-link').hide();
    window.eventBus.$emit('show-search');
};

window.hideSearchBox = function(){
    $('#close-search-link').hide();
    $('#search-link').show();
    $('header nav .standard-link').show();
    $('#loading-search-link').hide();
    window.eventBus.$emit('hide-search');
}

$('#search-link').on('click',function(){
    window.showSearchBox();
});

$('#close-search-link').on('click',function(){
    window.hideSearchBox();
});